import { c as _c } from "react/compiler-runtime";
import { ListItemCardMobile } from "@components/common/mobile/list-item-card-mobile";
import { SkeletonProjectListItemCard } from "@components/common/mobile/skeleton-project-list-item-card";
import { FaroTableBulkActions } from "@components/common/faro-table/faro-table-bulk-actions";
import { GROUPS_SORT_BY_MAP } from "@components/groups/groups-constants";
import { VirtualizedGrid } from "@components/virtualized/virtualized-grid";
import { Box } from "@mui-wrapper";
import { useGroupsPageBulkActions } from "@pages/groups/use-groups-page-bulk-actions";
import { useGroupMenuOptionsMobile } from "@pages/groups/use-group-menu-options-mobile";
import { generateGroupDetailsRoute } from "@router/router-helper";
import { selectedEntitiesSelector } from "@store/table/table-selector";
import { selectedSdbCompanySelector } from "@store/sdb-company/sdb-company-selector";
import { useAppSelector } from "@store/store-helper";
import { getProjectNumbersInGroup, getMemberCount } from "@utils/group-utils";
import defaultGroupThumbnail from "@assets/thumbnails/groups-thumbs/group-thumbnail_default.svg";
import { useDateTime } from "@hooks/use-date-time";
import { useHasUserValidFeatureCompanyLevel } from "@hooks/feature-control/use-has-user-valid-feature-company-level";
/**
 * Mobile-specific view for groups list with action bar and card layout.
 */
export function GroupsMobileView(t0) {
  const $ = _c(29);
  const {
    groups,
    sortBy,
    isLoading
  } = t0;
  const menuItems = useGroupMenuOptionsMobile();
  const {
    formatDate
  } = useDateTime();
  const {
    canAssignManagers
  } = useHasUserValidFeatureCompanyLevel();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = selectedEntitiesSelector("groups");
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const selectedEntities = useAppSelector(t1);
  const selectedSdbCompany = useAppSelector(selectedSdbCompanySelector);
  const selectedSortField = GROUPS_SORT_BY_MAP[sortBy].field;
  const sortField = selectedSortField === "members" && !canAssignManagers ? "createdDate" : selectedSortField;
  let t2;
  if ($[1] !== groups) {
    t2 = {
      groups
    };
    $[1] = groups;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const bulkActionsButtons = useGroupsPageBulkActions(t2);
  if (!selectedSdbCompany) {
    return null;
  }
  let t3;
  if ($[3] !== groups) {
    t3 = groups.map(_temp);
    $[3] = groups;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const allGroupIds = t3;
  let t4;
  if ($[5] !== formatDate || $[6] !== sortField) {
    t4 = function getSubtitle(group_0) {
      switch (sortField) {
        case "name":
        case "createdDate":
          {
            return `Created: ${formatDate(group_0.createdAt)}`;
          }
        case "members":
          {
            return `Managers: ${getMemberCount(group_0)}`;
          }
        case "projects":
          {
            return `Projects: ${getProjectNumbersInGroup(group_0)}`;
          }
        default:
          {
            return `Created: ${formatDate(group_0.createdAt)}`;
          }
      }
    };
    $[5] = formatDate;
    $[6] = sortField;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const getSubtitle = t4;
  let t5;
  if ($[8] !== canAssignManagers || $[9] !== sortField) {
    t5 = function getSecondaryText(group_1) {
      const managers = getMemberCount(group_1);
      const projects = getProjectNumbersInGroup(group_1);
      switch (sortField) {
        case "members":
          {
            return `Projects: ${projects}`;
          }
        case "projects":
          {
            return canAssignManagers ? `Managers: ${managers}` : "";
          }
        default:
          {
            return canAssignManagers ? `${managers} Managers • ${projects} Projects` : `${projects} Projects`;
          }
      }
    };
    $[8] = canAssignManagers;
    $[9] = sortField;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const getSecondaryText = t5;
  let t6;
  if ($[11] !== getSecondaryText || $[12] !== getSubtitle || $[13] !== menuItems || $[14] !== selectedSdbCompany.id) {
    t6 = group_2 => {
      const subtitle = getSubtitle(group_2);
      const secondaryText = getSecondaryText(group_2);
      return <Box key={group_2.id}><ListItemCardMobile item={group_2} image={group_2.thumbnailUrl?.length ? group_2.thumbnailUrl : defaultGroupThumbnail} imageFallbackSrc={defaultGroupThumbnail} imageAlt="Group thumbnail" title={group_2.name} href={generateGroupDetailsRoute(selectedSdbCompany.id, group_2.id)} subtitle={subtitle} secondaryText={secondaryText} menuItems={menuItems} /></Box>;
    };
    $[11] = getSecondaryText;
    $[12] = getSubtitle;
    $[13] = menuItems;
    $[14] = selectedSdbCompany.id;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== groups || $[17] !== isLoading || $[18] !== sortBy || $[19] !== t6) {
    t7 = <VirtualizedGrid key={sortBy} items={groups} isLoading={isLoading} renderSkeletonItem={_temp2} estimateSize={112} renderItem={t6} />;
    $[16] = groups;
    $[17] = isLoading;
    $[18] = sortBy;
    $[19] = t6;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  let t8;
  if ($[21] !== allGroupIds || $[22] !== bulkActionsButtons || $[23] !== isLoading || $[24] !== selectedEntities.length) {
    t8 = <FaroTableBulkActions bulkActionsButtons={bulkActionsButtons} numberOfSelectedRows={selectedEntities.length} isLoading={isLoading} allRowIds={allGroupIds} />;
    $[21] = allGroupIds;
    $[22] = bulkActionsButtons;
    $[23] = isLoading;
    $[24] = selectedEntities.length;
    $[25] = t8;
  } else {
    t8 = $[25];
  }
  let t9;
  if ($[26] !== t7 || $[27] !== t8) {
    t9 = <>{t7}{t8}</>;
    $[26] = t7;
    $[27] = t8;
    $[28] = t9;
  } else {
    t9 = $[28];
  }
  return t9;
}
function _temp2(index) {
  return <Box key={index}><SkeletonProjectListItemCard /></Box>;
}
function _temp(group) {
  return group.id;
}